import { getContext } from '@picsart/miniapps-sdk';

export interface IObjectApply {
  miniapp_package_id: string;
  item_id: string;
  tool: string;
  source: string;
}

export interface IObjectExport {
  id: string;
  destination: string;
  source: string;
}

class Analytics {
  private context = getContext();

  objectExport({ id, destination, source }: IObjectExport) {
    getContext().handlers.sendAnalytics({
      eventName: 'object_export',
      params: {
        id,
        destination,
        source,
      },
    });
  }

  objectApply({ miniapp_package_id, item_id, tool, source }: IObjectApply) {
    this.context.handlers.sendAnalytics({
      eventName: 'object_apply',
      params: {
        miniapp_package_id,
        item_id,
        tool,
        source,
      },
    });
  }
}

export default new Analytics();
